// SALDP row-level security. Added by Sullivan Digital, 2026-10-26. Licensed under the GNU AGPL v3; see LICENSE-AGPL.txt.
import { Route } from "metabase/router";

export const ROW_ACCESS_ROLES_TAB = "row-access-roles";

const rowAccessRoles = () =>
  import(
    /* webpackChunkName: "admin-saldp" */ "./RowAccessRolesPage/RowAccessRolesPage"
  ).then(({ RowAccessRolesPage }) => ({ Component: RowAccessRolesPage }));

export const getRowAccessRolesRoutes = () => (
  <Route path={ROW_ACCESS_ROLES_TAB} lazy={rowAccessRoles} />
);
